import SingleProgress from './singleProgress/SingleProgress';
import { Container, Row } from 'react-bootstrap';

type Step = {
  label: string;
  id: number;
};
interface ProgressBarProps {
  steps: Step[];
  activeStep: number;
}

const ProgressBar = ({ steps, activeStep }: ProgressBarProps) => {
  const displayProgress = steps.map((item) => {
    return (
      <SingleProgress
        item={item}
        key={item.id}
        activeStep={activeStep}
      />
    );
  });

  return (
    <Container className="justify-content-center small">
      <Row className="text-center py-4 px-2">{displayProgress}</Row>
    </Container>
  );
};

export default ProgressBar;
